import './index.scss';

import { Component } from 'react';

import { BraxImageSource } from '../../types';

export type BraxAvatarProps = BraxImageSource | {
    firstName: string,
    lastName: string
};

export class BraxAvatar extends Component<BraxAvatarProps> {

    render() {
        return 'src' in this.props ? (
            <img className="brax-avatar" referrerPolicy="no-referrer" {...this.props} />
        ) : (
            <span className="brax-avatar">{ this.props.firstName[0] }{ this.props.lastName[0] }</span>
        );
    }

}
